import HttpApi from 'i18next-http-backend';
import { InstanceFactoryOptions } from './types';
import { defaultRequestOptions } from './const';

export const createInstance = ({
  requestOptions = defaultRequestOptions,
  ...options
}: InstanceFactoryOptions = {}) =>
  new HttpApi(null, {
    requestOptions,
    ...options,
  });
